//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { compress } from '@/plugin/imagecompress.js'
import PictureList from '@/components/PictureList.vue'
export default {
  props: ['accept', 'FolderId', 'disable'],
  components: {
    PictureList
  },
  data() {
    return {
      uploadpicturelist: [],
      picturelist: [],
      pictureidlist: [],
      fileData: []
    }
  },
  mounted() {
    this.getFile()
  },

  methods: {
    getFile() {
      this.$refs.uploadfile.clearFiles()
      if (!this.FolderId) {
        this.uploadpicturelist = []
        return
      }
      this.$api
        .getFile(this.FolderId)
        .then(res => {
          if (res.Status === 1) {
            var list = []
            res.Entity.forEach(item => {
              list.push({
                name: item.FileName,
                url: 'data:image/png;base64,' + item.Contents,
                Id: item.Id
              })
            })
            this.uploadpicturelist = list

            var plist = []
            res.Entity.forEach(item => {
              plist.push('data:image/png;base64,' + item.Contents)
            })
            this.picturelist = plist
          } else {
            this.$alert(res.Message, '错误', {
              confirmButtonText: '确定'
            })
          }
        })
        .catch(function(res) {
          this.$alert('获取数据错误！', '错误', {
            confirmButtonText: '确定'
          })
        })
    },
    async changeUploadFile(changefile, fileList) {
      this.fileData = []
      this.pictureidlist = []
      for (var file of fileList) {
        if (file.Id !== undefined) {
          this.pictureidlist.push(file.Id)
        } else {
          if (file.raw.type.indexOf('video') > -1) {
            // this.fileData.push(file.raw)
            var cfile = await this.compressVideo(file.raw)
            console.log(cfile)
          } else {
            let isLt2M = file.raw.size / 1024 < 512 // 判定图片大小是否小于0.5mb
            if (isLt2M) {
              this.fileData.push(file.raw)
            } else {
              var res = await compress.compressAccurately(file.raw, 512)

              this.fileData.push(res)
            }
          }
        }
      }
      this.submitUploadFile()
    },
    submitUploadFile() {
      let fromData = new FormData()
      this.fileData.forEach(file => {
        fromData.append('files', file)
      })
      fromData.append('FolderId', this.FolderId || '')
      this.pictureidlist.forEach(id => {
        fromData.append('FileId', id)
      })
      this.$api
        .uploadFile(fromData)
        .then(res => {
          this.$emit('input', res.Entity)
        })
        .catch(function(res) {})
    },
    compressVideo(file) {
      return new Promise(async resolve => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/controls/uploadfile.vue